<div class="z-fx-col z-fx-start-center z-fx-gap-16 why-finder-container">
  @if (questionData?.whyFinder?.maxQuestions !== 1) {
    <div class="z-fx-col z-fx-auto z-fx-gap-8 messages">
      @for (message of messages; track trackByMessage(i, message); let i = $index) {
        @if (
          (message.role === 'assistant' || message.role === 'user') && (i >= messages.length - 3 || showAllMessages)
        ) {
          <div
            class="message"
            [class.interviewee]="message.role === 'user'"
            [class.interviewer]="message.role === 'assistant'"
            [style.color]="message.role === 'user' ? (ss.colors | async).text80 : (ss.colors | async).text"
          >
            {{ message?.message }}
          </div>
        }
      }
    </div>
    @if (loading$ | async) {
      <div class="dot-typing" [style.--text-color]="(ss.colors | async).text80"></div>
    }
    @if (!messages?.length && (loading$ | async) === false) {
      <div class="z-fx z-fx-center-center" [style.color]="(ss.colors | async).text80">
        <mat-icon class="error-icon" fontSet="zefplayer">placeholder</mat-icon>
      </div>
    }
    @if (showInput) {
      <div class="z-fx z-fx-none z-fx-gap-4 input-area">
        <textarea
          class="z-input"
          autocomplete="off"
          [autoSize]="true"
          [autoSizeMinRows]="1"
          name="free-text"
          [maxLength]="getCharsLimit()"
          #input
          [placeholder]="placeholder || ''"
          [value]="initValue"
          [style.color]="(ss.colors | async).text80"
          [style.background-color]="(ss.colors | async).mood20"
          (keyup.enter)="addComment(input.value); input.value = ''"
          (input)="onValueChanged()"
        ></textarea>
        @if (!interviewDone || input.value) {
          <button
            class="z-fx z-fx-center-center send-button button-size-{{ ss.viewSize | async }}"
            [style.background-color]="(ss.colors | async)?.mood"
            [style.color]="(ss.colors | async)?.primary"
            (click)="addComment(input.value); input.value = ''"
          >
            <mat-icon fontSet="zefplayer">send</mat-icon>
          </button>
        }
        @if (interviewDone && !input.value) {
          <button
            class="next-button"
            [style.background-color]="(ss.colors | async)?.button"
            [style.color]="(ss.colors | async)?.buttonContrast"
            (click)="nextQuestion.emit()"
          >
            @if (isLast) {
              {{ 'Finish' | translateText: 'finishButton' }}
            }
            @if (!isLast) {
              {{ 'Next' | translateText: 'nextButton' }}
            }
          </button>
        }
      </div>
    }
    @if (showAllMessages === false && messages?.length > 3) {
      <button
        class="show-all-button"
        [style.background-color]="(ss.colors | async)?.mood"
        [style.color]="(ss.colors | async)?.primary"
        (click)="showAllMessages = true"
      >
        ···
      </button>
    }
  } @else {
    <div class="z-fx-col z-fx-start-start z-fx-gap-24 why-finder-container">
      <div class="z-fx-col z-fx-auto z-fx-gap-8 messages">
        <div class="message" [style.color]="(ss.colors | async).text80">
          {{ messages[0]?.message }}
        </div>
      </div>
      @if (loading$ | async) {
        <div class="z-fx-col z-fx-w100 z-fx-center-center">
          <div class="dot-typing" [style.--text-color]="(ss.colors | async).text80"></div>
        </div>
      }
      <textarea
        class="z-input"
        autocomplete="off"
        [autoSize]="true"
        [autoSizeMinRows]="5"
        name="free-text"
        [maxLength]="getCharsLimit()"
        #simpleInput
        [placeholder]="placeholder || ''"
        [value]="simpleAnswer"
        [style.color]="(ss.colors | async).text80"
        [style.background-color]="(ss.colors | async).mood20"
        (blur)="saveSimpleAnswer(simpleInput.value)"
        (input)="onValueChanged()"
      ></textarea>
      <basic-button
        class="no-input-next-button"
        [waitNext]="simpleSaveInProgress$ | async"
        (click)="saveSimpleAnswer(simpleInput.value, true)"
      >
        @if (isLast) {
          {{ 'Finish' | translateText: 'finishButton' }}
        }
        @if (!isLast) {
          {{ 'Next' | translateText: 'nextButton' }}
        }
      </basic-button>
    </div>
  }
</div>

@if (!showInput && questionData?.whyFinder?.maxQuestions !== 1) {
  <basic-button class="no-input-next-button" (click)="nextQuestion.emit()">
    @if (isLast) {
      {{ 'Finish' | translateText: 'finishButton' }}
    }
    @if (!isLast) {
      {{ 'Next' | translateText: 'nextButton' }}
    }
  </basic-button>
}
